<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<task-comm-cd-search-view :scrId="scrId"></task-comm-cd-search-view>
			</sf-card>
		</div>
		<div class="sf-col sf-col-20 grid-wrapper">
			<div style="grid-column: 1/3; grid-row: 1/2">
				<task-comm-cd-mst-table-view @popupOpen="popupOpen" :scrId="scrId"></task-comm-cd-mst-table-view>
			</div>
			<div style="grid-column: 3/5; grid-row: 1/2">
				<task-comm-cd-table-view :scrId="scrId"></task-comm-cd-table-view>
			</div>
		</div>
		<popup-view ref="popupView" @popupOpen="popupOpen" :scrId="scrId"></popup-view>
	</div>
</template>

<script>
import PopupView from './Popup/PopupView.vue';
import TaskCommCdSearchView from './Search/TaskCommCdSearchView.vue';
import TaskCommCdMstTableView from './Table/TaskCommCdMstTableView.vue';
import TaskCommCdTableView from './Table/TaskCommCdTableView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { TaskCommCdSearchView, TaskCommCdMstTableView, TaskCommCdTableView, PopupView },
	methods: {
		popupOpen(param) {
			this.$refs.popupView.open(param);
		}
	}
};
</script>

<style>
.flex-row-container {
	display: flex;
	flex-direction: row;
	gap: 16px;
}
.grid-wrapper {
	overflow: hidden;
	display: grid;
	flex: 1;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows: repeat(1, 1fr);
	grid-gap: 20px;
}
</style>
